import React, { useState, useEffect } from 'react';
import './style.css';
import ItemComponent from '../ItemComponent';

const HomeCarousel = (props) =>{


  const { dataList, scrolling=true } = props;

  // const [width, setWidth] = useState(window.innerWidth);

  const [quantity, setQuantity] = useState(
    (window.innerWidth/200) + 1 < 5 ? parseInt( (window.innerWidth/200) + 1 ):5
  );
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(quantity);
  const [items, setItems] = useState(dataList.sort((a, b) => Math.random() < 0.6 ? 1 : -1).slice(0, quantity));
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState(dataList);

  // console.log("items ", items, dataList);

  useEffect(() => {
    const handleResizeWindow = () => {
      // setWidth(window.innerWidth);
      setQuantity((window.innerWidth/200) + 1 < 5 ? parseInt( (window.innerWidth/200) + 1 ):5)
    }
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);

    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  useEffect(() => {
    setEnd(quantity)
  },[quantity, dataList, data])

   // // Increase Quantity
  const nextPageBooks = () => {
    const value = parseInt(end)
    if( value >= 15 ){
      setStart(0)
      setEnd(quantity)
      setItems(dataList.slice(0, quantity))
      // console.log(">>>>>>>>* ", 0, quantity, ">>>>>>>", dataList)
    }else{
      setStart(value)
      setEnd(value + quantity)
      setItems(dataList.slice(value, value + quantity))
      // console.log(">>>>>>>>** ", value, value + quantity, ">>>>>>>", dataList)
    }
  }
  // // Decrease Quantity
  const prevPageBook = () => {
    const value = parseInt(start - quantity)
    if(value > 0) {
      setStart(value)
      setEnd(value + quantity)
      setItems(dataList.slice(value, value+quantity))
      // console.log("<<<<<<<<<* ", value, value + quantity, "<<<<<", dataList.slice(value, value+quantity))
    }else{
      setStart(0)
      setEnd(quantity)
      setItems(dataList.slice(0, quantity))
      // console.log("<<<<<<<<<** ", 0, quantity, "<<<<<", dataList.slice(0, quantity))
    }
  };


  return (
    <div className="home-carousel">
      {scrolling && <div className="carousel-custom-prev" role="button" tabIndex="0" 
          onClick={()=> prevPageBook()}
        >
          <span aria-hidden="true" className="carousel-custom-prev-icon"></span>
          <span className="visually-hidden">Previous</span>
        </div>
      }
      {items.map((author)=>{
          return <ItemComponent 
            key={author._id} 
            random={author}
            imgCss=''
            className='home-item'
          /> 
      })}
      {scrolling &&
        <div className="carousel-custom-next" role="button" tabIndex="0" 
          onClick={()=> nextPageBooks()}
        >
          <span aria-hidden="true" className="carousel-custom-next-icon"></span>
          <span className="visually-hidden">Next</span>
        </div>
      }
    </div>
  )


}

export default HomeCarousel;